import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { getstaffwithid } from "../../../api/FacultyService";
import {
  closeModal,
  formatDate,
  formatDateTime,
  ToastMain,
  SweetAlertShow,
} from "../../master/Master";
import CourseNFeeTab from "./CourseNFeeTab";
import MarksReportTab from "./MarksReportTab";
import AttendanceTab from "./AttendanceTab";
import TranctionTab from "./TranctionTab";
import DocumentsTab from "./DocumentsTab";
import { imgBaseUrl } from "../../../api/api";
import Document from "./DocumentsTab";
import AdmissionForm from "./Addmission";
import Emi from "./EmiTab";
import Review from "./Review";
import StudentHeader from "./StudentHeader";
import { studentDetails } from "../../../api/Student";

const StudentProfile2 = ({}) => {
  const hasAccess = usePrivateLink();
  // const { id } = useParams();
  const navigate = useNavigate();
  const [Tab, setTab] = useState("CourseNFee");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const [Data, setData] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const studentId = queryParams.get("id");

  useEffect(() => {
    if (studentId) {
      getStudent();
    }
  }, [studentId]);

  const getStudent = async () => {
    setLoading(true);
    try {
      const response = await studentDetails(`id=${studentId}`);
      if (response.data) {
        setData(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  // permissions for user role
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className="col-md-2 left-pane">
                  <StudentHeader data={"Student Portal"} />
                </div>
                <div className="col-md-10">
                  <div className="row">
                    {/* User Sidebar */}
                    <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                      {/* User Card */}
                      <div className="card mb-6">
                        <div className="card-body pt-12">
                          <div className="user-avatar-section">
                            <div className="d-flex align-items-center flex-column">
                              <div
                                className="d-flex justify-content-center mb-4"
                                data-bs-toggle="modal"
                                data-bs-target="#imgModal"
                                style={{ cursor: "pointer" }}
                              >
                                {Data?.student?.profile_picture ? (
                                  <img
                                    src={
                                      imgBaseUrl +
                                      Data?.student?.profile_picture
                                    }
                                    alt="Student Profile"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle border border-1 border-primary d-flex align-items-center justify-content-center bg-label-primary"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      color: "white",
                                      fontSize: "50px",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {Data?.student?.name
                                      ? Data?.student?.name.charAt(0)
                                      : "U"}
                                  </div>
                                )}
                              </div>
                              <div className="user-info text-center">
                                <h5>
                                  {Data?.student?.name} (
                                  {Data?.student?.registration_no})
                                </h5>
                                <span className="badge bg-label-success rounded-pill">
                                  Active
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div className="d-flex justify-content-around flex-wrap my-6 gap-0 gap-md-3 gap-lg-4">
                                            <div className="d-flex align-items-center me-5 gap-4">
                                                <div className="avatar">
                                                    <div className="avatar-initial bg-label-primary rounded">
                                                        <i className="ri-check-line ri-24px" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <h5 className="mb-0">1.23k</h5>
                                                    <span>Due Fees</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-4">

                                                <div className="avatar">
                                                    <div className="avatar-initial bg-label-primary rounded">
                                                        <i className="ri-briefcase-line ri-24px" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <h5 className="mb-0">568</h5>
                                                    <span>Class Rank</span>
                                                </div>

                                            </div>
                                        </div> */}
                          <div className="d-flex justify-content-between border-bottom mb-2">
                            <h5 className="pb-4  mb-3">Details</h5>
                            {hasAccess('/student/batch/enroll') && (
                              <Link
                                to={`/student/batch/enroll?student_id=${Data?.student?.id}`}
                                className="btn btn-sm mt-3 mb-3 btn-outline-primary "
                              >
                                Add In Batch
                              </Link>
                            )}
                          </div>
                          <div className="info-container">
                            <ul className="list-unstyled mb-6">
                              <li className="mb-2">
                                <span className="h6">Father's Name: </span>
                                <span>{Data?.student?.father_name}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Mother's Name: </span>
                                <span>{Data?.student?.mother_name}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Email: </span>
                                <span> {Data?.student?.email}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Phone: </span>
                                <span>
                                  {Data?.student?.phone},{" "}
                                  {Data?.student?.secondary_mobile}
                                </span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Category: </span>
                                <span>{Data?.student?.category}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Gender: </span>
                                <span>{Data?.student?.gender}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">DOB: </span>
                                <span>{formatDate(Data?.student?.dob)}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Address: </span>
                                <span>
                                  {Data?.student?.village}{" "}
                                  {Data?.student?.district}{" "}
                                  {Data?.student?.state} -{" "}
                                  {Data?.student?.zipcode}
                                </span>
                              </li>

                              <li className="mb-2">
                                <span className="h6">Admission Date: </span>
                                <span>
                                  {formatDate(Data?.student?.admission_date)}
                                </span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Aadhar: </span>
                                <span>{Data?.student?.aadhar}</span>
                              </li>
                              <span className="text-danger mt-2 mb-2">
                                -----Additional Details-----
                              </span>
                              <li className="mb-2">
                                <span className="h6">Last School: </span>
                                <span>{Data?.student?.school}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Last Education: </span>
                                <span>{Data?.student?.education}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Refer by: </span>
                                <span>{Data?.student?.referred_by}</span>
                              </li>
                            </ul>
                            <div className="d-flex justify-content-center">
                              {hasAccess('/student/update') && (
                                <Link to={`/student/update?id=${studentId}`}>
                                  <button className="btn btn-outline-primary px-4 py-2 me-2">
                                    <i className="bi bi-pencil-square me-1"></i>{" "}
                                    Edit Profile
                                  </button>
                                </Link>
                              )}
                              {/* <a
                                                    href="javascript:;"
                                                    className="btn btn-outline-danger suspend-user waves-effect"
                                                >
                                                    Suspend
                                                </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /User Card */}
                    </div>
                    {/*/ User Sidebar */}
                    {/* User Content */}
                    <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                      {/* User Tabs */}
                      <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-md-row flex-wrap mb-6 row-gap-2">
                          {hasAccess('/student/course_fee') && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "CourseNFee" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("CourseNFee")}
                              >
                                <i className="ri-group-line me-1_5" />
                                Course N Fees
                              </a>
                            </li>
                          )}
                          {hasAccess('/student/marks_report') && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "MarksReportTab" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("MarksReportTab")}
                              >
                                <i className="ri-lock-2-line me-1_5" />
                                Marks Report
                              </a>
                            </li>
                          )}
                          {hasAccess('/student/attendance/list') && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "Attendance" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("Attendance")}
                              >
                                <i className="ri-link-m me-1_5" />
                                Attendance Report
                              </a>
                            </li>
                          )}
                          {(hasAccess('/fees/transactions') || hasAccess('/student/fee/transaction/delete') || hasAccess('/student/fees/receipt')) && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "Transaction" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("Transaction")}
                              >
                                <i className="ri-link-m me-1_5" />
                                Transaction Report
                              </a>
                            </li>
                          )}
                          {/* 
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link waves-effect waves-light ${Tab === 'Kit' ? 'active' : ''}`}
                                                href="#"
                                                onClick={() => setTab('Kit')}
                                            >
                                                <i className="ri-link-m me-1_5" />
                                                Kit Report
                                            </a>
                                        </li> */}
                          {hasAccess('/student/admission/form/print') && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "Addmission" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("Addmission")}
                              >
                                <i className="ri-bookmark-line me-1_5" />
                                Admission
                              </a>
                            </li>
                          )}
                          {(hasAccess('/student/documents') || hasAccess('/student/documents/add')) && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "Documents" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("Documents")}
                              >
                                <i className="ri-bookmark-line me-1_5" />
                                Documents
                              </a>
                            </li>
                          )}
                          {(hasAccess('/student/documents') || hasAccess('/student/documents/add')) && (
                            <li className="nav-item">
                              <a
                                className={`nav-link waves-effect waves-light ${
                                  Tab === "Review" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setTab("Review")}
                              >
                                <i className="ri-bookmark-line me-1_5" />
                                Review
                              </a>
                            </li>
                          )}

                          {hasAccess('/hostel') && (
                            <>
                              {Data?.student?.hostelstudent?.id && (
                                <li className="nav-item">
                                  <Link
                                    to={`/hostel/profile?id=${Data?.student?.hostelstudent?.id}`}
                                    className={`nav-link waves-effect waves-light`}
                                  >
                                    <i className="ri-arrow-right-line me-1_5" />
                                    Go To Hostel
                                  </Link>
                                </li>
                              )}
                            </>
                          )}

                          {/* {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.frontend_url == '/student/course_fee')) && (
                                            <li className="nav-item">
                                                <a
                                                    className={`nav-link waves-effect waves-light ${Tab === 'Emi' ? 'active' : ''}`}
                                                    href="#"
                                                    onClick={() => setTab('Emi')}
                                                >
                                                    <i className="ri-bookmark-line me-1_5" />
                                                    Emi 
                                                </a>
                                            </li>
                                        )} */}

                          <li className="nav-item">
                            <Link
                              to={`/student/form?id=${Data?.student?.id}`}
                              className={`nav-link waves-effect waves-light`}
                            >
                              <i className="ri-printer-line me-1_5" />
                              Admission From
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to={`/student/demo?id=${Data?.student?.id}`}
                              className={`nav-link waves-effect waves-light`}
                            >
                              <i className="ri-printer-line me-1_5" />
                              Demo From
                            </Link>
                          </li>
                        </ul>
                      </div>

                      {Tab == "CourseNFee" && (
                        <CourseNFeeTab data={Data} getStudent={getStudent} />
                      )}
                      {Tab == "MarksReportTab" && (
                        <MarksReportTab data={Data} getStudent={getStudent} />
                      )}
                      {Tab == "Attendance" && <AttendanceTab data={Data} />}
                      {Tab == "Transaction" && (
                        <TranctionTab data={Data} getStudent={getStudent} />
                      )}
                      {Tab == "Addmission" && <AdmissionForm data={Data} />}
                      {Tab == "Documents" && (
                        <Document data={Data} getStudent={getStudent} />
                      )}
                      {Tab == "Review" && (
                        <Review data={Data} getStudent={getStudent} />
                      )}
                      {/* {Tab == 'Emi' && <Emi data={Data} getStudent={getStudent}/>} */}
                    </div>
                    {/*/ User Content */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      <div
        className="modal fade"
        id="imgModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="d-flex justify-content-between">
                <h4 className="text-primary">Profile Image</h4>
                <button
                  className="btn btn-sm btn-outline-primary mt-3 mb-3"
                  data-bs-dismiss="modal"
                >
                  close
                </button>
              </div>
              {Data?.student?.profile_picture ? (
                <img
                  src={`${imgBaseUrl}${Data?.student?.profile_picture}`}
                  alt="Student Profile"
                  style={{
                    width: "600px",
                    height: "600px",
                    objectFit: "cover",
                    // borderRadius: "50%",
                  }}
                />
              ) : (
                <div
                  className="rounded-circle border border-1 border-primary d-flex align-items-center justify-content-center bg-label-primary"
                  style={{
                    width: "150px",
                    height: "150px",
                    color: "white",
                    fontSize: "50px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                >
                  {Data?.student?.name ? Data?.student.name.charAt(0) : "U"}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentProfile2;
